/** @jsxImportSource @emotion/react */

import { Button, Modal } from "antd";
import { LOGO_MAIN } from "assets/Common";
import CloseIcon from "assets/temporary/icons/Close.png";

import { ModalCustomStyle } from "./index.style";

interface Props {
  isOpenModal: boolean;
  handleCloseModal: () => void;
  titleModal?: string;
  logoHeading?: boolean;
  bodyModal: JSX.Element;
  footerModal?: JSX.Element;
  headerBackground?: string;
  heightBackground?: number;
}

export const ModalCustom = (props: Props) => {
  const {
    isOpenModal,
    handleCloseModal,
    titleModal,
    bodyModal,
    footerModal,
    headerBackground = "",
    heightBackground = 0,
    logoHeading = false,
  } = props;
  return (
    <Modal
      open={isOpenModal}
      closable={false}
      onCancel={handleCloseModal}
      css={ModalCustomStyle.modalContainer}
      footer={false}
      centered
    >
      <div
        css={ModalCustomStyle.header.index(headerBackground, heightBackground)}
      >
        {titleModal && (
          <span css={ModalCustomStyle.header.title}>{titleModal}</span>
        )}
        {logoHeading && (
          <div css={ModalCustomStyle.header.logo}>
            <img src={LOGO_MAIN} alt="..." />
          </div>
        )}
        <Button
          onClick={handleCloseModal}
          css={ModalCustomStyle.header.buttonClose}
        >
          <img src={CloseIcon} alt="" />
        </Button>
      </div>

      {bodyModal}

      {footerModal}
    </Modal>
  );
};
